<mat-card>
  <mat-card-header>
    <mat-card-title
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
    >
      {{ title }}
    </mat-card-title>
  </mat-card-header>

  <!-- Form -->
  <mat-card-content style="margin: 2em 0; max-height: 65vh; overflow: auto">
    <form
      id="form"
      [formGroup]="formulario"
      (ngSubmit)="enviar()"
      class="column"
    >
      <mat-form-field>
        <mat-label>Nombre de la API</mat-label>
        <input matInput formControlName="apiName" />
      </mat-form-field>

      @if (!this.data?._id) {
        <mat-form-field>
          <mat-label>Fecha de Creación</mat-label>
          <input
            matInput
            [matDatepicker]="picker1"
            formControlName="fechaCreacion"
          />
          <mat-datepicker-toggle matSuffix [for]="picker1" />
          <mat-datepicker #picker1 />
        </mat-form-field>
      }

      <mat-form-field>
        <mat-label>Fecha de Expiración</mat-label>
        <input
          matInput
          [matDatepicker]="picker2"
          formControlName="fechaExpiracion"
        />
        <mat-datepicker-toggle matSuffix [for]="picker2" />
        <mat-datepicker #picker2 />
      </mat-form-field>

      @if (!this.data?._id) {
        <mat-form-field>
          <mat-label>Cliente</mat-label>
          <mat-select formControlName="idCliente">
            @for (c of clientes; track c) {
              <mat-option [value]="c._id">
                {{ c.nombre }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-form-field>
        <mat-label>Roles</mat-label>
        <mat-select formControlName="roles" multiple>
          @for (r of roles; track r) {
            <mat-option [value]="r">
              {{ r | titlecase }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </mat-card-content>

  <mat-divider />

  <!-- Botones -->
  <mat-card-actions class="gap-3" style="margin: 0.5em">
    <button
      class="botonSpinner"
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!formulario.valid || loading"
      form="form"
    >
      <div
        class="loadSpinnerButton"
        [style.display]="loading ? 'flex' : 'none'"
      >
        <mat-spinner
          class="mx-2"
          [diameter]="25"
          mode="indeterminate"
          color="warn"
        />
      </div>
      <span [style.display]="loading ? 'none' : 'block'">Guardar</span>
    </button>

    <button mat-raised-button type="button" (click)="close()">Volver</button>
  </mat-card-actions>

  <!-- Progress Bar  -->
  <mat-card-footer>
    <mat-progress-bar [mode]="loading ? 'indeterminate' : 'determinate'" />
  </mat-card-footer>
</mat-card>
